import { Action } from './type';

export const TwitterProfileRegex = /^(https:\/\/)?(www\.)?(x|twitter)\.com\/[a-zA-Z0-9_]{5,15}$/;

export const TwitterTweetRegex =
  /^https:\/\/(www\.)?(x|twitter)\.com\/[a-zA-Z0-9_]{5,15}\/status\/\d+$/;

export const urlRegex = new RegExp(
  '^https?:\\/\\/' + // 协议
    '([a-zA-Z0-9\\-]+\\.)+[a-zA-Z]{2,}' + // 域名
    '(\\/[-a-zA-Z0-9@:%_\\+.~#?&//=]*)?' + // 路径
    '(\\?[;&a-zA-Z0-9%_\\+.~#?&//=]*)?' + // 查询字符串
    '(\\#[-a-zA-Z0-9_]*)?$', // 片段标识符
);

export const checkActionsEmpty = (actions?: Action[]) => !actions?.some(i => i.type && i.data);

export const objectToArray = (obj: Record<string, string>) => {
  return Object.keys(obj).map(key => ({
    key: key,
    value: obj[key],
  }));
};

export const arrayToObject = (arr: { key: string; value: string }[]) => {
  return arr.reduce((acc, { key, value }) => {
    acc[key] = value;
    return acc;
  }, {});
};
